import { createSlice } from '@reduxjs/toolkit'
import type {
  Allergy,
  MedicalCondition,
} from '@dataTypes/allergy-medical-condition.types'
import { fetchAllergiesCatalog } from '../actions/allergies.action'
import { fetchMedicalConditionsCatalog } from '../actions/medical-conditions.action'

type AllergyMedicalConditionState = {
  allergies: Allergy[]
  medicalConditions: MedicalCondition[]
  allergiesLoading: boolean
  allergiesLoaded: boolean
  medicalConditionsLoading: boolean
  medicalConditionsLoaded: boolean
  allergiesError: string | null
  medicalConditionsError: string | null
}

const initialState: AllergyMedicalConditionState = {
  allergies: [],
  medicalConditions: [],
  allergiesLoading: false,
  allergiesLoaded: false,
  medicalConditionsLoading: false,
  medicalConditionsLoaded: false,
  allergiesError: null,
  medicalConditionsError: null,
}

const allergyMedicalConditionSlice = createSlice({
  name: 'allergyMedicalCondition',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllergiesCatalog.pending, (state) => {
        state.allergiesLoading = true
        state.allergiesError = null
      })
      .addCase(fetchAllergiesCatalog.fulfilled, (state, action) => {
        state.allergies = action.payload
        state.allergiesLoading = false
        state.allergiesLoaded = true
        state.allergiesError = null
      })
      .addCase(fetchAllergiesCatalog.rejected, (state, action) => {
        state.allergiesLoading = false
        state.allergiesError =
          action.error.message ?? 'Failed to load allergies'
      })
      .addCase(fetchMedicalConditionsCatalog.pending, (state) => {
        state.medicalConditionsLoading = true
        state.medicalConditionsError = null
      })
      .addCase(fetchMedicalConditionsCatalog.fulfilled, (state, action) => {
        state.medicalConditions = action.payload
        state.medicalConditionsLoading = false
        state.medicalConditionsLoaded = true
        state.medicalConditionsError = null
      })
      .addCase(fetchMedicalConditionsCatalog.rejected, (state, action) => {
        state.medicalConditionsLoading = false
        state.medicalConditionsError =
          action.error.message ?? 'Failed to load medical conditions'
      })
  },
})

export default allergyMedicalConditionSlice.reducer
